/* eslint-disable space-before-function-paren */
/* eslint-disable no-sequences */
/* eslint-disable keyword-spacing */
import axios from 'axios';
import { store } from '../../store/store';
import { BASE_URL } from './api.config';
import { route } from '../../routing/navigation';
import { bookList } from '../../constants/bookList';
import {
    sessionAccessTokenSelector,
    sessionTokenExpirationSelector,
} from '../../routes/auth/auth.selectors';

import { clearSession } from '../../routes/auth/auth.actions';

const apiClient = axios.create({
    baseURL: BASE_URL,
});

const abortController = new AbortController();

apiClient.interceptors.request.use(
    (config) => {
        const reduxStore = store.getState();
        const token = sessionAccessTokenSelector(reduxStore);
        const tokenExpiration = sessionTokenExpirationSelector(reduxStore);

        if (tokenExpiration && tokenExpiration * 1000 < Date.now() - 120000) { // 2 minutes
            abortController.abort();
            store.dispatch(clearSession());
            route(bookList.auth.login);
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        config.headers['Access-Control-Allow-Credentials'] = true,
        config.headers['Content-Type'] = 'application/json';

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
    // function (error) {
    //     const originalRequest = error.config;
    //     if(error.response.status === 401 && !originalRequest._retry) {
    //         if(isRefreshing) {
    //             return new Promise(function (resolve, reject) {
    //                 failedQueue.push({ resolve, reject });
    //             })
    //                 .then((token) => {
    //                     originalRequest.headers.Authorization
    //                         = `Bearer ${token}`;
    //                     return axios(originalRequest);
    //                 })
    //                 .catch((err) => Promise.reject(err));
    //         }

    //         originalRequest._retry = true;
    //         isRefreshing = true;

    //         const reduxStore = store.getState();
    //         const refreshToken = sessionRefreshTokenSelector(reduxStore);

    //         axios.defaults.headers.common.Authorization
    //             = `Bearer ${refreshToken}`;

    //         return new Promise(function (resolve, reject) {
    //             axios
    //                 .post(`${BASE_URL}auth/refresh_token`)
    //                 .then((res) => {
    //                     if(res.status === 201) {
    //                         store.dispatch(updateToken(res.data));
    //                         axios.defaults.headers.common.Authorization
    //                             = `Bearer ${res.data.access_token}`;
    //                         originalRequest.headers.Authorization
    //                             = `Bearer ${res.data.access_token}`;
    //                         processQueue(null, res.data.access_token);
    //                         resolve(axios(originalRequest));
    //                     }
    //                 })
    //                 .catch((err) => {
    //                     processQueue(err, null);
    //                     reject(err);
    //                     store.dispatch(clearSession());
    //                 })
    //                 .finally(() => {
    //                     isRefreshing = false;
    //                 });
    //         });
    //     }
    //     return Promise.reject(error);
    // }
);

const { get, post, put, patch, delete: destroy } = apiClient;

export { get, post, put, patch, destroy };
